import { FormDialog } from "components/dialogs/Dialogs";
import { FormGroup, Textarea } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { useState } from "react";
import { useMutation } from "@apollo/client";
import { gql } from "__generated__/gql";
import { Box } from "@mui/material";

type UpdateStatusNoteDialogProps = {
	statusChangeId: number;
	comment?: string;
	skipperComment?: string;
	open: boolean;
	onClose: () => void;
	onSuccess?: () => void;
};

const UpdateStatusNoteDialog = ({
	statusChangeId,
	comment,
	skipperComment,
	open,
	onClose,
	onSuccess,
}: UpdateStatusNoteDialogProps) => {
	const [ value, setValue ] = useState<string>(comment ?? "");
	const [ updateStatusChangeComment, { loading } ] = useMutation(updateStatusChangeCommentMutation);

	const handleSave = (e: React.FormEvent) => {
		e.preventDefault();
		updateStatusChangeComment({
			variables: {
				id: statusChangeId,
				comment: value || null,
			},
		}).then(() => {
			onSuccess?.();
			onClose();
		});
	};

	return (
		<FormDialog
			open={open}
			onClose={onClose}
			form="updateStatusNoteForm"
			loading={loading}
			title={intl.formatMessage({ id: "CARGO_ACTION_NOTES" })}
			maxWidth="sm"
		>
			<form onSubmit={handleSave} id="updateStatusNoteForm">
				<Box mb={2}>
					<FormGroup label={intl.formatMessage({ id: "SKIPPER_COMMENT" })} overflow={"hidden"}>
						<Textarea
							value={skipperComment}
							disabled
							style={{ minHeight: "100px" }} />
					</FormGroup>
				</Box>

				<Box mb={2}>
					<FormGroup label={intl.formatMessage({ id: "NOTE" })} overflow={"hidden"}>
						<Textarea
							value={value}
							onChange={(e) => setValue(e.target.value)}
							style={{ minHeight: "100px" }}
							onFocus={(e) => {
								const length = e.target.value.length;
								e.target.setSelectionRange(length, length);
							}}
							autoFocus />
					</FormGroup>
				</Box>
			</form>
		</FormDialog>
	);
};

const updateStatusChangeCommentMutation = gql(`#graphql
	mutation updateStatusChangeComment($id: Long!, $comment: String) {
		updateStatusChangeComment(id: $id, comment: $comment)
	}
`);

export default UpdateStatusNoteDialog;
